// this is an autogenerated file from DesignSystem/EditAutomation/SaveAction/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_SaveAction($event_id: uuid!) {
  events_events_change_log(
    where: {
      event_id: { _eq: $event_id }
      updates_processed_status: { _eq: PROCESSING }
    }
  ) {
    event_id
    updates_processed_status
  }
}

`